export default (set, get, projectDetails) => {

  const state = get() || {};
  const cabinetVisualizer = state.cabinetVisualizer || {};
  const projects = cabinetVisualizer.projects || {};

  const projectId = projectDetails.projectId;
  const existingProject = projects[projectId] || {};

  const updatedProject = {
    ...existingProject,
    roomType: projectDetails.roomType,
    name: projectDetails.name,
    description: projectDetails.description
  };

  const updatedCabinetVisualizer = {
    ...cabinetVisualizer,
    projects: {
      ...projects,
      [projectId]: updatedProject
    }
  };

  const updatedState = {
    ...state,
    cabinetVisualizer: updatedCabinetVisualizer
  };

  set(
    updatedState,
    false,
    { type: 'cabinetVisualizer/updateProjectDetails' }
  );
};